import * as yup from 'yup';

const emailWithTldSchema = yup
  .string()
  .trim()
  .required('Email is required')
  .email('Invalid email')
  // Final label (TLD) must be >= 2 chars; allows subdomains.
  .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u, 'Domain must include a TLD (e.g., ".com")');

export const isValidEmail = (email: string): boolean => {
  return emailWithTldSchema.isValidSync(email);
};
